"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : NOTE : STYLES --------------- ++++++++++ */


var _default = {
  note: {
    '& p': {
      color: "rgba(6, 43, 117, 0.5)",
      extend: _index.theme.typography.size.xxsmall
    }
  }
};
exports.default = _default;